import * as React from "react";
import type { SVGProps } from "react";
const SvgClockForward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m14.517 14.4-3.6-1.2V8.182m9.6 3.818a9.6 9.6 0 1 0-1.284 4.8m-1.35-5.853 2.4 2.4 2.4-2.4"
    />
  </svg>
);
export default SvgClockForward;
